module.exports = "<footer>\n  soy el footer {{anio}}\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /Users/administrador/Trabajos/pascal3/src/app/components/footer/footer.component.html
// module id = ../../../../../src/app/components/footer/footer.component.html
// module chunks = main